import { tokens } from './tokens'

// Old export names, kept so call sites keep working. Each value now resolves to a role in tokens.ts —
// new code should import `tokens` directly. Four names used to hold one gray (#71717A / #717179); they
// are the same token now.

// deprecated
export const icon = {
    white: '#FFFFFF',
    gray: tokens.text.tertiary,
    red: '#E24858',
    yellow: '#FFBA0D',
    blue: '#25BEFF',
    green: '#41802E',
    orange: '#FF8200',
    purple: '#5634CF',
    black: '#000000',
}
export type TIconColor = keyof typeof icon

// deprecated
export const status = {
    red: { default: '#E24858', light: '#F6C8CD' },
    yellow: { default: tokens.intent.warning, light: '#FFF4DB' },
    green: { default: '#41802E', light: '#CFDFCB' },
    gray: { default: tokens.text.tertiary, light: '#DADADA' },
}
export type TStatusColors = keyof typeof status

export const accent = {
    pink: tokens.intent.brand,
    yellow: '#FBDD40',
    yellowStroke: '#D9BD2E',
}

export const background = {
    white: tokens.surface.default,
    base: tokens.surface.raised,
    sub: tokens.surface.sunken,
    border: tokens.line.default,
    hover: tokens.line.strong,
    panel: tokens.surface.panel,
    hairline: tokens.line.subtle,
    page: tokens.surface.page,
    band: '#DCECF5',
    divider: '#B6B6B6',
}
export type TBackgroundColor = keyof typeof background

// Veil behind modals and dialogs: the warm page tone at 55%, paired with a 3px backdrop blur.
// Mantine's modal takes colour and opacity separately, so BaseModal passes background.page + 0.55.
export const overlay = `color-mix(in srgb, ${background.page} 55%, transparent)`

export const text = {
    title: tokens.text.primary,
    base: tokens.text.secondary,
    muted: tokens.text.tertiary,
    ink: '#222721',
    secondary: '#585858',
    // Past-due dates: "needs a look" without the alarm of red
    warning: tokens.intent.warning,

    // deprecated
    black: '#000000',
    light: tokens.text.tertiary,
    white: '#FFFFFF',
    orange: '#FF8200',
    green: '#41802E',
    red: '#E24858',
    purple: '#5634CF',
}
export type TTextColor = keyof typeof text

export const control = {
    primary: {
        label: text.ink,
        bg: accent.yellow,
        hover: '#E8CD37',
        highlight: '#FFF08A',
        stroke: accent.yellowStroke,
    },
    secondary: {
        label: '#3F3F46',
        bg: '#FDFDFD',
        stroke: '#E4E4E7',
        hover: '#F4F4F5',
        highlight: '#D4D4D8',
    },
    destructive: {
        label: tokens.text.inverse,
        bg: tokens.intent.danger,
        hover: '#701513',
        highlight: '#E53742',
    },
}

export const semantic = {
    success: {
        base: '#16A249',
        hover: '#10652F',
        faint: '#DAE0D6',
    },
    // Misnamed: this is the danger red (error toasts). Past-due amber is `tokens.intent.warning`.
    warning: {
        base: tokens.intent.danger,
        hover: '#701513',
        faint: '#FCEEEA',
    },
    highlight: {
        base: '#FBDD40',
        hover: '#C39A2B',
        faint: '#16A249',
    },
    blue: {
        base: '#3881B4',
        faint: '#D0ECF9',
    },
}
